import React from "react";
import { useSites } from "@/context/SiteContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Buildings } from "@phosphor-icons/react";

export default function SiteSelector({ showAll = true, className = "" }) {
  const { sites, activeSiteId, setActiveSiteId } = useSites();
  if (!sites || sites.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="site-selector">
      <Buildings size={16} className="text-[#1B4776]" weight="duotone" />
      <Select value={activeSiteId} onValueChange={setActiveSiteId}>
        <SelectTrigger className="h-9 min-w-[220px] rounded-none sm:rounded-sm border-slate-300 bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {showAll && <SelectItem value="all">Tüm Şantiyeler</SelectItem>}
          {sites.map((s) => (
            <SelectItem key={s.id} value={s.id}>
              <span className="font-mono text-xs text-slate-500 mr-2">{s.code}</span>
              {s.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
